<template>
  <el-drawer @reload="$reloadHandle"
             title="师傅工牌背面打印" size="55%"
             :before-close="handleClose"
             :visible.sync="drawer"
             direction="rtl"
             :modal-append-to-body="true"
             custom-class="demo-drawer"
             ref="drawer"
  >
    <div style="margin-top: 20px; text-align: center">
      <button @click="print()">打印</button>
    </div>
    <div id="print" style="width: 55mm; height: 88mm; background-image: url('/img/back_group_img.png'); background-size: cover; background-repeat: no-repeat; background-position: center; min-height: 88mm; border-radius: 15px; overflow: hidden;">
      <div id="divPrint" class="print_div_style" v-for="item in dataList">
        <div class="container1" style="height: 100%; display: flex; align-items: center; justify-content: center; width: 100%;">

          <!-- 添加动态图片区域 -->
          <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;">
            <!-- 第一个动态图片 -->
            <div style="display: flex; flex-direction: column; align-items: center; margin-top:8px; margin-bottom: 2px;">
              <div style="background-color: white; padding: 5px;">
                <img :src="recMoneyPic" alt="收款码" style="width: 25mm; height: 25mm;">
              </div>
              <div style="font-size: 12px; font-weight: bold; color: #fff; margin-top: 5px;">收款码</div>
            </div>

            <!-- 第二个动态图片 -->
            <div style="display: flex; flex-direction: column; align-items: center;margin-top: 5px;">
              <div style="background-color: white; padding: 5px;">
                <img src="/img/gong_zhong_hao.png" alt="华帝服务公众号" style="width: 25mm; height: 25mm;">
              </div>
              <div style="font-size: 10px; font-weight: bold; color: #fff; margin-top: 5px;">华帝服务公众号</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import printJS from "print-js";
import api from "@/api/projectApi";
import VueBarcode from "vue-barcode";
import {siteMixins} from "@/mixins/tabChang";
import request from "@/router/axios";


export default {
  name: "engineerBackPrint",
  props: ['multi', 'param', 'collectPrintIdList', 'dataId'],
  mixins: [siteMixins],
  components: {VueBarcode},
  created() {
    this.currentTime()

  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      recMoneyPic: "/img/user-logo-001.png",
      nowDate: null,
      formData: {},
      dataList: [{
        qrCodeUrl: 'https://www.w3schools.com/howto/img_qr.png', // 测试二维码图片
        orderNo: 'TEST-20240101-001',
        customerName: '测试客户',
        phone: '13800138000',
        address: '测试地址',
        partsName: '测试配件',
        quantity: 1,
        price: 100
      }], // 添加测试数据
      drawer: true,
      orderDates: []
    };

  },
  methods: {
    currentTime() {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth() + 1;
      let day = date.getDate();
      //如果格式是MM则需要此步骤，如果是M格式则此处注释掉
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day <= 9) {
        day = "0" + day;
      }
      let strDate = year + "-" + month + "-" + day;
      this.nowDate = strDate
    },
    getData() {
      // 检查dataId是否存在
      if (!this.dataId) {
        console.warn('No dataId provided, using default recMoneyPic');
        return;
      }

      this.$http.post(api.snSiteEngineer.getDataByIdUrl, {
        id: this.dataId
      }).then(res => {
        // 确保res.data.data存在且不为null
        if (res.data && res.data.data) {
          let data = res.data.data;
          if (data.recMoneyPic) {
            this.recMoneyPic = data.recMoneyPic;
          }
        } else {
          console.warn('No data returned from server, using default recMoneyPic');
        }
      }).catch(error => {
        console.error('Error fetching data:', error);
        // 错误时保持默认值
      })



      // request({
      //   url: api.snSiteEngineer.getDataByIdUrl,
      //   method: 'post',
      //   data: {
      //     id: this.dataId
      //   },
      //   isLoading: true,
      //   modalStrictly: true,
      // }).then(response => {
      //   this.tenant = response.data.data
      // })
    },
    print() {

      printJS({
        printable: "print", // 标签元素id
        type: "html", // 打印类型
        targetStyles: ["*"],
        scanStyles: false,
        style: `@page {
          margin: 0;
          size: 55mm 88mm; /* 明确指定打印尺寸 */
        }
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          background: none !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        #print {
          background-image: url('/img/back_group_img.png') !important;
          background-size: cover !important;
          background-repeat: no-repeat !important;
          background-position: center center !important;
          width: 55mm !important;
          height: 88mm !important;
          position: relative !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          overflow: hidden !important;
          margin: 0 auto !important;
          border-radius: 15px !important;
        }
        #print .container1 {
          height: 100% !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 100% !important;
        }
        /* 动态图片区域样式 - 与预览保持一致 */
        #print .container1 > div {
          position: relative !important;
          text-align: center !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          height: 100% !important;
          padding: 0 !important;
          width: 100% !important;
        }
        /* 第一个动态图片 */
        #print .container1 > div > div:nth-child(1) {
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          margin-top: 8px !important;
          margin-bottom: 2px !important;
        }
        /* 第一个动态图片的容器 */
        #print .print_div_style .container1 > div > div:nth-child(1) > div {
          background-color: white !important;
          padding: 5px !important;
        }
        /* 第一个动态图片 */
        #print .container1 > div > div:nth-child(1) img {
          width: 25mm !important;
          height: 25mm !important;
          margin: 0 auto !important;
          display: block !important;
          object-fit: contain !important;
        }
        /* 第一个动态图片的文字 */
        #print .container1 > div > div:nth-child(1) > div:last-child {
          font-size: 12px !important;
          font-weight: bold !important;
          color: #fff !important;
          margin-top: 5px !important;
          text-align: center !important;
          width: 100% !important;
          background: none !important;
        }
        /* 第二个动态图片 */
        #print .container1 > div > div:nth-child(2) {
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          margin-top: 5px !important;
        }
        /* 第二个动态图片的容器 */
        #print .print_div_style .container1 > div > div:nth-child(2) > div {
          background-color: white !important;
          padding: 5px !important;
        }
        /* 第二个动态图片 */
        #print .container1 > div > div:nth-child(2) img {
          width: 25mm !important;
          height: 25mm !important;
          margin: 0 auto !important;
          display: block !important;
          object-fit: contain !important;
        }
        /* 第二个动态图片的文字 */
        #print .container1 > div > div:nth-child(2) > div:last-child {
          font-size: 10px !important;
          font-weight: bold !important;
          color: #fff !important;
          margin-top: 5px !important;
          text-align: center !important;
          width: 100% !important;
          background: none !important;
        }
        /* 确保所有子元素都正确显示 */
        #print * {
          box-sizing: border-box !important;
        }
        /* 移除打印时不需要的边框 */
        #print .print_div_style {
          padding: 0 !important;
          border: none !important;
          margin: 0 !important;
        }`,
        ignoreElements: ["no-print"], // 接受打印父 html 元素时应忽略的 html id 数组。
        properties: {
          ignoreElements: ["no-print"],
          backgroundColor: true, // 确保背景颜色和图片被打印
          backgroundImage: true // 确保背景图片被打印
        },

      });

    },
    handleClose() {
      this.drawer = false;
      this.$emit('update:visiable', false)
    }
  },
};
</script>

<style lang="scss" scoped>
#print {
  * {
    font-size: 11px;
  }

  // 确保背景图片在预览和打印时都能显示
  background-image: url('/img/back_group_img.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 88mm;
  width: 55mm;
  display: flex;
  align-items: center;
  justify-content: center;

  table {
    border-right: 1px solid #000000;
    border-bottom: 1px solid #000000;
    text-align: center;
  }

  table th {
    border-left: 1px solid #000000;
    border-top: 1px solid #000000;
    text-align: center;
  }

  table td {
    border-left: 1px solid #000000;
    border-top: 1px solid #000000;
  }

  td {
    font-size: 10px;
  }

  a {
    text-decoration: none;
    color: #08acee;
  }

  button {
    outline: 0;
  }

  img {
    border: 0;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0;
    font: inherit;
    color: inherit;
    outline: none;
  }

  li {
    list-style: none;
  }

  a {
    color: #666;
  }

  .clearfix::after {
    clear: both;
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
  }

  .container1 {
    width: 100%;
    //margin: 100px auto;
    //border: 1px solid #f1f1f1;
    //padding: 0 50px 10px;
    /* background-color: #e9e9e9; */
  }

  .top-img2 {
    /* display: flex; */
    position: relative;
    height: 80px;
    margin-top: 20px;
  }

  .div1 {
    width: 36%;
  }

  .div2 {
    width: 20%;
  }

  .img1 {
    width: 150px;
    margin-left: 100px;

  }

  .title {
    margin: 0;
    width: 100%;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
  }

  .title1 {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
  }

  .img2 {
    position: absolute;
    right: 0;
    top: 0;
    width: 80px;
    height: 50px;

  }

  .top2 {
    display: flex;
    padding: 5px;
    justify-content: space-between;
  }

  .span1 {
    display: inline-block;
    width: 60px;
  }

  .span2 {
    display: inline-block;
    // width: 150px;
  }

  .span6 {
    margin-top: 5px;
    width: 200px;
  }

  .print_div_style {
    page-break-after: always;
    padding: 0;
    border: none;
    margin-top: 0;
  }

  .wid4 {
    width: 4%;
  }

  .wid13 {
    width: 13%;
  }

  .wid9 {
    width: 9%;
  }

  .wid16 {
    width: 16%;
  }

  .wid10 {
    width: 10%;
  }

  .wid18 {
    width: 18%;
  }

  .wid6 {
    width: 6%;
  }

  .wid5 {
    width: 5%;
  }

  .wid7 {
    width: 7%
  }

  .wid8 {
    width: 8%;
  }

  .wid15 {
    width: 15%;
  }

  .wid5 {
    width: 5%;
  }

  .wid14 {
    width: 14%;
  }

  .wid12 {
    width: 12%;
  }


  .table-div {
    text-align: center;
    width: 100%
  }

  .wid25 {
    width: 25%;
  }

  .wid30 {
    width: 30%;
  }

  .wid100 {
    width: 100%;
  }

  .table-class {
    text-align: center;
    border-spacing: 0;
    overflow: hidden;
    table-layout: fixed;
  }

  .wid85 {
    width: 85%;
  }

  .td-font-size {
    font-size: 10px;
  }

  .td-font-size-small {
    font-size: 6px;
  }

  .th-font-size {
    font-size: 10px;
  }

  td th {
    height: 14.5px;
    overflow: hidden;
    white-space: nowrap;
  }

  .font-left {
    text-align: left !important;
  }

  .font-center {
    text-align: center !important;
  }
}
</style>
